import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
export var onKnowledgeCardShown = function onKnowledgeCardShown(props) {
  var source = props.source,
    cardType = props.cardType;
  return {
    action: 'shown',
    actionSubject: 'aiAnswerDialog',
    actionSubjectId: 'knowledgeCard',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      cardType: cardType
    })
  };
};
export var onKnowledgeCardLinkClick = function onKnowledgeCardLinkClick(props, location) {
  var source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerDialog',
    actionSubjectId: 'knowledgeCardLink',
    source: source,
    eventType: 'track',
    attributes: _objectSpread(_objectSpread({}, filterCommonAttributes(props)), {}, {
      location: location
    })
  };
};